import React from 'react'
import foods from 'assets/img/lead-form-finish.jpg'
import { X } from 'react-feather'
import env from 'env'
import TrackableButton from '../../theme/TrackableButton'
import TrackableExternalLink from '../../theme/TrackableExternalLink'
import GTMHiddenFields from './GTMHiddenFields'

export default function LeadSuccess(props) {

  const { data, closeModal, catererName } = props
  const releasable = data.status === 'pending_verification'

  const showScheduleNow = data.occasion?.groups?.includes('b2b')

  return (
    showScheduleNow ?
    <LeadSuccessScheduleNow
      data={data}
      closeModal={closeModal}
      catererName={catererName}
      releasable={releasable}
    /> :
    <LeadSuccessDefault
      data={data}
      closeModal={closeModal}
      catererName={catererName}
      releasable={releasable}
    />
  )
}

function LeadSuccessDefault({ data, closeModal, catererName, releasable}) {
  return (
    <div
      style={{ backgroundColor: '#00aeef' }}
      className="relative bg-blue min-h-screen md:min-h-0 flex flex-col items-center justify-center"
    >
      <GTMHiddenFields data={data} />

      <div className="absolute top-0 right-0 p-2">
        <div className="flex items-center h-full">
          <button
            children={<X className="w-4 text-blue" />}
            className="bg-gray-200 rounded-full h-6 w-6 flex items-center justify-center"
            onClick={closeModal}
          />
        </div>
      </div>
      <img src={foods} />
      <div className="text-center p-12 pt-0">
        <Heading releasable={releasable} />
        { data.meta?.caterer_id && catererName && (
          <p className="font-light text-base text-white mb-2">
            We'll gather a catering bid from {catererName}, plus we'll get you bids 
            from other popular food trucks!
          </p>
        )}
        <p className="font-light text-base text-white">
          {releasable ? <ReleasableMessage data={data} /> : <Message closeModal={closeModal} /> }
        </p>
        <TrackableButton
          children="Close"
          className="mt-8 bg-white text-blue text-xl px-10 py-1 font-platform font-light"
          onClick={closeModal}
          trackedGroup="[LeadForm][Success]"
          trackedTitle="[LeadForm][Success] Close Button clicked"
        />
      </div>
    </div>
  )
}

function ReleasableMessage(props) {
  const { data } = props

  return (
    <>
      { data.cc_auth === 'pending' ? (
        <>
          Please review and finalize your event listing so food trucks can start
          bidding on your event. We've sent an email with a link to review, confirm 
          and finalize your catering request.
        </>
      ) : data.payer == 'attendee' ? (
        <>
          Please review & confirm your event details so food trucks can start
          applying to participate in your event. If you don't get an email check
          your spam folder or you may have entered the wrong email address.
        </>
      ) : (
        <>
          Please review & confirm your details so food trucks can start bidding
          on your event. We've sent you an email.
        </>
      )}
          
    </>
  )
}

function LeadSuccessScheduleNow({closeModal, data, catererName, releasable}) {
  const calenderUrl = env.HUBSPOT_CALENDAR_URL
  return (
    <div
      style={{ backgroundColor: '#00aeef' }}
      className="relative min-h-screen md:min-h-0 flex flex-col items-center justify-center"
    >
      <GTMHiddenFields data={data} />

      <div className="absolute top-0 right-0 p-2">
        <div className="flex items-center h-full">
          <button
            children={<X className="w-4 text-blue" />}
            className="bg-gray-200 rounded-full h-6 w-6 flex items-center justify-center"
            onClick={closeModal}
          />
        </div>
      </div>
      <img src={foods} />
      <div className="text-center p-12 pt-0">
        <Heading releasable={releasable} showScheduleNow />
        { data.meta?.caterer_id && catererName && (
          <p className="font-light text-base text-white mb-2">
            We'll gather a catering bid from {catererName}, plus we'll get you bids
            from other popular food trucks!
          </p>
        )}
        <TrackableExternalLink
          children="Schedule Now"
          className="inline-block my-8 bg-white text-blue text-xl px-10 py-1 font-platform font-light"
          href={calenderUrl}
          onClick={closeModal}
          trackedGroup="[LeadForm][Success]"
          trackedTitle="[LeadForm][Success] Schedule Now clicked"
        />
        <p className="font-light text-base text-white">
          {releasable ? <ReleasableMessage data={data} /> : <Message closeModal={closeModal} /> }
        </p>
      </div>
    </div>
  )
}

function Heading({releasable, showScheduleNow}) {
  const title = releasable ?
                'Check Your Email!' :
                showScheduleNow ?
                "Thanks for sharing your event details! Schedule a call with a Concierge now." :
                "Thanks for sharing your event details!"

  return (
    <h2 className={`${releasable ? 'text-4xl' : 'text-2xl'} font-platform text-white text-center`}>
      {title}
    </h2>
  )
}

function Message({closeModal}) {
  return (
    <>
      A confirmation email with next steps will arrive soon.
      If you don't see it within 10 minutes, check your spam folder or contact us at{' '}
      <TrackableExternalLink
        children="concierge@roaminghunger.com"
        className="inline-block underline"
        href="mailto:concierge@roaminghunger.com"
        onClick={closeModal}
        trackedGroup="[LeadForm][Success]"
        trackedTitle="[LeadForm][Success] Concierge email clicked"
        />.
    </>
  )
}
